import IsibuteDocumentComponent from "./IsibuteDocumentComponent";

class IsibuteDocumentEmphasis extends IsibuteDocumentComponent {};

export default IsibuteDocumentEmphasis;